<template src="./DescargarArchivoV2.html"></template>

<script>
import TarjetaDescargar from "./TarjetaDescargar/TarjetaDescargar"
import { leerDocumentosAsociados, leerArchivo } from "../../apiService/request/CrudDocumentos";
import Icono from "../Icono/Icono";
  export default {
    name: "descargar-archivo-v2",
    data() {
      return {
        dialogo: false,
        banderaConsultando: false,
        iconoDescargar:
            "M43,37.3H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1v-4.7C44,37.8,43.6,37.3,43,37.3z M42,42H2v-2.7h40V42zM10.8,23.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v30.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L22.7,34.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L10.8,23.9z",
        documentos: null,
        documentosConArchivo: null
      };
    },
    props: {
      idOrigen: {
        type: String,
        default: null
      },
      coleccionOrigen: {
        type: String,
        default: null
      }
    },
    watch: {
      documentos(newValue, oldValue) {
        if(newValue) {
          this.$emit('cantidadArchivos', newValue.length);
          this.documentosConArchivo = newValue.filter( documento => documento.nombre);
        } else {
          this.$emit('cantidadArchivos', 0);
        }
      }
    },
    
    async mounted() {
      console.log('idOrigen', this.idOrigen);
      await this.obtenerDocumentosAsociados();
      this.$root.$on('archivoSubidoExitosamente', async (data) => {
        await this.obtenerDocumentosAsociados();
      });
    },   
    beforeDestroy() {
      this.$root.$off('archivoSubidoExitosamente');
    },
    methods: {
      async obtenerDocumentosAsociados() {
        try {
          this.banderaConsultando = true;
          const respuesta = await leerDocumentosAsociados({
            id: this.idOrigen ? this.idOrigen : this.$store.getters.getId,
            origen: this.coleccionOrigen
          })
          if (respuesta.data && respuesta.data.data && respuesta.data.data.data) {
            this.documentos = respuesta.data.data.data;
          } 
        } catch (err) {
          console.log(err);          
          this.banderaConsultando = false;
          } finally {
          this.banderaConsultando = false;
        }
      },
      async visualizarDocumento(docId) {
        try {
          this.banderaConsultando = true;
          const respuesta = await leerArchivo({
            docId
          })
          if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.url) {
            window.open(respuesta.data.data.url);
          } else {
            console.log('respuesta visualizarDocumento', respuesta);
          }
        } catch (err) {
          console.log('visualizarDocumento', err)          
          this.banderaConsultando = false;
          } finally {
          this.banderaConsultando = false;
        }
      }
    },
    components: {
      TarjetaDescargar,
      Icono
    }
    
  }
</script>

<style lang="scss" src="./DescargarArchivoV2.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/DescargarArchivoV2/DescargarArchivoV2.vue